import { render, staticRenderFns } from "./mgmtSettings.vue?vue&type=template&id=b6de8b22&scoped=true&"
import script from "./mgmtSettings.vue?vue&type=script&lang=js&"
export * from "./mgmtSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6de8b22",
  null
  
)

export default component.exports